import React, { FunctionComponent } from 'react';
import type { CandidateRating as CandidateRatingModel } from '../../../core/models/models';
import noPhoto from '../../../assets/images/no_photo_candidate.png';
import { StarIcon, HollowStarIcon } from '../../UI/StarIcon/StarIcon';
import './CandidateRating.scss';

export const CandidateRating: FunctionComponent<{
  rating: CandidateRatingModel;
}> = ({ rating }) => {
  const { rating: stars, comment, created_at: createdAt } = rating;

  return (
    <div className='candidate_rating'>
      <img className='reviewer_photo' src={noPhoto} alt='Candidate photo' />
      <div className='rating_details'>
        <div className='star_rating'>
          {Array.from({ length: stars }, (_, i) => (
            <StarIcon key={i} />
          ))}
          {Array.from({ length: 5 - stars }, (_, i) => (
            <HollowStarIcon key={`hollow-${i}`} />
          ))}
        </div>
        <div className='created_at'>{createdAt}</div>
        <div className='comment_title'>Comments:</div>
        <p>{comment}</p>
      </div>
    </div>
  );
};
